import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';

export const useIsSimplifyNavExperimentEnabled = () => {
	const { data: projectContext } = useProjectContext();
	const [expConfig] = UNSAFE_noExposureExp('jsw_simplify_navigation_m2');

	const isJsw = projectContext?.projectType === SOFTWARE_PROJECT;
	const isProjectAdmin = projectContext?.isProjectAdmin;
	const isTmp = !!projectContext?.simplified;

	const isEligible = isJsw && isTmp && isProjectAdmin;

	if (isEligible) {
		return expConfig.get('isEnabled', false);
	}
	return false;
};
